import React from "react";
import {
	Link
} from "react-router-dom";
import config from './../../config.js';
import Loading from './../../../components/loading.js';

import Actionsheets from './../../../components/actionsheets.js';
import Dropdown from './../../../components/dropdown.js';
import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
	style: {
		top: '45px',
		right: 0
	}
}, (n) => notification = n);

export default class ListBrainlabel extends React.Component {
	constructor(props) {
		super(props);
		//console.log(props);
		let user = {};
		let uistyle = {};
		if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
			user = JSON.parse(localStorage.user);
			if (typeof user.company.type !== 'undefined' && user.company.type !== '') {
				uistyle = JSON.parse(user.company.type);
			}
		}
		let pathurl = props.pathurl; // + props.location.search;
		this.state = {
			user: user,
			projectid: props.data.projectid || 0,
			type: props.data.type,
			loading: true,
			isaction: false,
			tasks: [],
			actiontaskid: '',
			intervalId: '',
			search: '',
			uistyle: uistyle,
			pathurl: pathurl
		}

		this.actionClose = this.actionClose.bind(this);
		this.actionSubmit = this.actionSubmit.bind(this);
		this.removeTask = this.removeTask.bind(this);

		this.download_roivis_data = this.download_roivis_data.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
	}


	componentDidMount() {
		this.onInitial(this.props.data);
	}

	componentWillUnmount() {
		clearInterval(this.state.intervalId);
	}

	componentWillReceiveProps(nextProps) {
		//this.onInitial(nextProps.data);
	}

	notify(message) {
		notification.notice({
			content: <span>{message}</span>,
			duration: 4,
			style: {
				'bottom': 0,
				'right': 0
			}
		});
	}

	actionClose() {
		this.setState({
			isaction: false,
			actiontaskid: ''
		})
	}

	onInitial(data) {
		const me = this;
		const {
			user,
			search
		} = me.state;
		const {
			projectid,
			type
		} = data;
		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid || 0,
			type: type,
			request: 'getresult',
			search: search,
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});
		fetch(config.host + '/brainlabel/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					me.setState({
						tasks: json.data,
						loading: false
					});

					json.data.forEach(t => {
						if (t.status === '1' || t.status === '0') {
							//console.log(t);
							me.getusertask(t.id, t.task_id);

						}
					});

				} else {
					me.setState({
						tasks: [],
						loading: false
					});
				}
			})
			.catch(function (error) {
				console.log(error);
			});



		let intervalId = setInterval(function () {
			me.IntervalStatus();
		}, 15000);
		me.setState({
			intervalId: intervalId
		});
	}

	IntervalStatus() {
		const me = this;
		me.state.tasks.forEach(t => {
			if (t.status === '1' || t.status === '0' || typeof t.status === 'undefined') {
				//console.log(t)
				me.getusertask(t.id, t.task_id);
			}
		});
	}

	//get brainlabel task status as percent
	getusertask(taskid, brainlabelid) {
		const me = this;
		const {
			user,
			projectid,
			tasks
		} = me.state;

		const postdata = {
			taskid: taskid,
			brainlabelid: brainlabelid,
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			request: 'getusertask',
			Authorization: localStorage.token
		};

		fetch(config.host + '/brainlabel/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					tasks.forEach(t => {
						if (t.id === taskid) {
							t.status = json.data.task_state;
							t.percent = json.data.complete_per;
						}
					});

					me.setState({
						tasks: tasks
					});

					if (json.data.complete_per == '100') me.onInitial(this.props.data);
				} else {
					//me.notify(json.message);
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}



	actionSubmit(id) {
		this.setState({
			actiontaskid: id,
			isaction: true
		})
	}

	removeTask() {
		const me = this;
		let {
			user,
			actiontaskid,
			projectid,
			tasks
		} = me.state;
		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			taskid: actiontaskid,
			request: 'remove',
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});
		//console.log(postdata);
		fetch(config.host + '/brainlabel/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					tasks.map((t, i) => {
						if (t.id === actiontaskid) {
							tasks.splice(i, 1);
						}
						return t;
					});
					me.setState({
						tasks: tasks
					});
				}

				me.setState({
					loading: false,
					isaction: false
				});

			})
			.catch(function (error) {
				console.log(error);
			});
	}


	download_roivis_data(id, tid, type) {
		const me = this;

		let {
			user,
			projectid
		} = me.state;
		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			taskid: id,
			brainlabelid: tid,
			request: 'download_data',
			download_type: type,
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});
		//console.log(postdata);
		fetch(config.host + '/brainlabel/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				console.log(json);
				me.notify(json.message);
				if (json.status === 1 && json.data !== false) {
					window.location.href = json.data.oss_url;
				}

				me.setState({
					loading: false
				});

			})
			.catch(function (error) {
				console.log(error);
			});
	}


	qc(taskid, ncstate) {
		const me = this;
		const {
			user,
			projectid,
			tasks
		} = me.state;

		const postdata = {
			taskid: taskid,
			ncstate: ncstate,
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			request: 'nc_state',
			Authorization: localStorage.token
		};

		fetch(config.host + '/brainlabel/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					tasks.forEach(t => {
						if (t.id === taskid) {
							t.nc_state = ncstate;
						}
					});

					me.setState({
						tasks: tasks
					});
				} else {
					me.notify(json.message);
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}


	handleInputChange(event) {
		const me = this;
		const target = event.target;
		const name = target.name;
		const value = target.value;
		me.setState({
			[name]: value
		})
	}



	handleSubmit(event) {
		event.preventDefault();
		event.stopPropagation();
		this.onInitial(this.props.data);
		return;
	}

	onKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
		// 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
		if (event.key === 'Enter') {
			event.preventDefault();
			event.stopPropagation();
			this.handleSubmit();
		}
	}


	render() {
		const {
			user,
			projectid,
			tasks,
			uistyle,
			pathurl
		} = this.state;
		let tbody = null;

		if (tasks.length) {
			tbody = tasks.map((m, i) => {
				return (
					<tr key={i} data-id={m.id}>
						<td><Link to={`/console/subject_files/${m.project_id || 0}/${m.subject_id}/0/?to=${pathurl}`} title={`序列编号:${m.input_patientid} (${m.file_id}) `}>{m.subject_number} </Link> {m.subject_name && <i>{m.subject_name}</i>} </td>
						{uistyle.is_subjectuid && <td>{m.subject_uid}</td>}
						<td>{m.subject_gender == 0 ? '男' : '女'}</td>
						<td>{m.subject_age}</td>
						<td>
							{m.date_created}
						</td>
						<td>
							{m.date_update}
						</td>
						<td>
							{(() => {
								switch (m.status) {	//	1:正在处理；2：处理成功 ；3：失败；	
									case '0':
										return ('等待处理');
										break;
									case '1':
										return (

											<div className="progress">
												<div className="progress-bar progress-bar-striped progress-bar-animated " style={{ width: m.percent }} aria-valuenow={m.percent} aria-valuemin="0" aria-valuemax="100">{m.percent}%</div>
											</div>

										);

									case '2':
										return (<span className="text-success">处理完成</span>);

									case '3':
										return (' 处理失败 ');

									default:
										return (

											<div className="progress">
												<div className="progress-bar progress-bar-striped progress-bar-animated " style={{ width: m.percent }} aria-valuenow={m.percent} aria-valuemin="0" aria-valuemax="100">{m.percent}%</div>
											</div>

										);
										break;
								}
							})()}
						</td>
						{/* 
						<td>
							{m.status === '2' && uistyle.is_ncstate &&
								<div className="btn-group btn-group-xs" role="group" aria-label="Basic example">
									<button type="button" className={`btn  ${m.nc_state === "1" ? "btn-primary " : "btn-light"}`} onClick={() => { this.qc(m.id, "1") }}>可用</button>
									<button type="button" className={`btn  ${m.nc_state === "0" ? "btn-primary" : "btn-light"}`} onClick={() => { this.qc(m.id, "0") }}>不可用</button>
								</div>
							}
						</td>
 */}
						<td>
							{(() => {
								if (m.status === '2') {
									const t1viewerurl = config.t1viewer + '?uid=' + user.id + '&cid=' + user.company_id + '&tid=' + m.task_id + '&requrl=' + config.host + '/t1view/index/';

									return (
										<div>
											<span className="mr-2">
												<a className="text-body" href={t1viewerurl} target="_blank"><i className="fa fa-brain text-success"></i> 在线阅片</a>
											</span>

											<div className="float-right">
												<Dropdown direction="dropleft">
													<div>
														<i className="fa fa-bars"></i> <i className="fa fa-caret-down"></i>
													</div>
													<div>
														<div className="dropdown-header">操作菜单</div>
														{user.company_id == 1 &&
															<Link to={`/console/t1/test_report/${projectid}/${m.id}/${m.task_id}`} className="dropdown-item cursor"><i className="fa fa-solar-panel"></i> 创建体检报告</Link>
														}
														{user.company_id == 1 &&
															<Link to={`/console/t1/test_list_report/${projectid}/${m.id}/${m.task_id}`} className="dropdown-item cursor"><i className="fa fa-list-ul"></i> 查看体检报告</Link>
														}

														{uistyle.is_t1report &&
															<Link to={`/console/t1/create_report/${projectid}/${m.id}/${m.task_id}`} className="dropdown-item cursor"><i className="fa fa-solar-panel"></i> 创建报告</Link>
														}
														{uistyle.is_t1report &&
															<Link to={`/console/t1/list_report/${projectid}/${m.id}/${m.task_id}`} className="dropdown-item cursor"><i className="fa fa-list-ul"></i> 下载报告</Link>
														}

														{uistyle.is_t1result && user.level == 5 &&
															<div className="dropdown-item cursor" onClick={() => this.download_roivis_data(m.id, m.task_id, 'roivis')}><i className="fa fa-download text-success"></i> 阅片数据 </div>
														}
														{uistyle.is_t1result && user.level == 5 &&
															<div className="dropdown-item cursor" onClick={() => this.download_roivis_data(m.id, m.task_id, 'result')}><i className="fa fa-download text-success"></i> 结果数据 </div>
														}

														<div className="dropdown-item cursor" onClick={() => this.download_roivis_data(m.id, m.task_id, 'statistic')}><i className="fa fa-download text-success"></i> 统计数据 </div>

														<div className="dropdown-divider"></div>

														<div className="dropdown-item text-danger cursor" onClick={() => { this.actionSubmit(m.id) }}><i className="fa fa-trash-alt text-danger"></i> 删除</div>
													</div>
												</Dropdown>
											</div>
										</div>
									)
								} else {
									return (
										<div>
											<a className="text-danger remove" onClick={() => { this.actionSubmit(m.id) }}>删除</a>
										</div>
									)
								}
							})()}
						</td>
					</tr>)
			});
		}
		return (
			<div className="mb-3 pb-3">
				<Loading display={this.state.loading} />
				<nav className="clearfix mb-3">
					<h4 className="animated fadeInLeft float-left"><i className="fa fa-data"></i> 全脑分割列表 <small>共{tasks.length}条</small></h4>
					<div className="float-right">
						<form className="form-inline" onSubmit={this.handleSubmit}>
							<div className="form-group">
								<input type="search" name="search" className="form-control form-control-sm" placeholder="受试者编号或创建日期等等" onChange={this.handleInputChange} onBlur={this.handleSubmit} value={this.state.search} />
							</div>
							<button type="submit" className="btn btn-dark btn-sm">搜索</button>
						</form>
					</div>
				</nav>
				{
					tasks.length > 0 &&
					<table className="table table-hover">
						<thead className="thead-dark">
							<tr>
								<th>受试者</th>
								{uistyle.is_subjectuid && <th>UID</th>}
								<th>性别</th>
								<th>年龄</th>
								<th>提交时间</th>
								<th>更新时间</th>
								<th>状态</th>
								{/* <th>{uistyle.is_ncstate && 'NC标注'}</th> */}
								<th className="text-right pr-3">操作</th>
							</tr>
						</thead>
						<tbody>{tbody}</tbody>
					</table>

				}
				{
					tasks.length === 0 && <p className="text-center text-muted py-5 my-5 shadow-sm">没有数据</p>
				}
				<Actionsheets display={this.state.isaction}>
					<ul className="list-group text-center">
						<li className="list-group-item disabled">确定要删除?</li>
						<li className="list-group-item text-danger" onClick={this.removeTask}>删除</li>
						<li className="list-group-item" onClick={this.actionClose}>取消</li>
					</ul>
				</Actionsheets>
			</div>

		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/console/uncategorized/list_brainlabel.js